module.exports = __webpack_public_path__ + "img/leaf.fe1ab427.svg";